import { render, staticRenderFns } from "./EventModification.vue?vue&type=template&id=0f46a9de&"
import script from "./EventModification.vue?vue&type=script&lang=js&"
export * from "./EventModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports